/* eslint-disable @typescript-eslint/no-unused-vars */
import { methodTypeFeature } from "./method-type.reducer";
import { methodTypeAdapter } from "./method-type.state";

const entityAdapters = methodTypeAdapter.getSelectors();
const { name, reducer, ...selectors } = methodTypeFeature;

export const methodTypeSelectors = {
  ...entityAdapters,
  ...selectors,
};